<template>
 <div style="width:100%;height: 100%;">
  <div id="map" style="width:100%;height: 100%;">
   <!-- 车辆信息框 -->
   <vehicle-info-modal ref="vehicleInfoModalRef"></vehicle-info-modal>
   <!-- 添加自定义点 -->
   <add-customer-point-modal ref="addCustomerPointModalRef" @on-add="onCustomPOIAdd"></add-customer-point-modal>
   <!-- 查看自定义点 -->
   <customer-point-detail-modal ref="customerPointDetailModalRef" @on-edit="onCustomPOIEdit"
                                @on-deleted="onCustomPOIDeleted"></customer-point-detail-modal>
   <!-- 修改自定义点 -->
   <modify-customer-point-modal ref="modifyCustomerPointModalRef"
                                @on-modify="onCustomPOIModify"></modify-customer-point-modal>
  </div>
  <!-- 工具栏 -->
<!--    <Input size="small" suffix="ios-search" placeholder="Enter text"-->
<!--           style=" width:200px; position: absolute; top: 5px; left: 5px;"/>-->
<!--    <Select-->
<!--     size="small"-->
<!--     suffix="ios-search"-->
<!--     style=" width:200px; position: absolute; top: 5px; left: 60px;"-->
<!--     placeholder="请输入地物点名称"-->
<!--     v-model="selectedPOI"-->
<!--     filterable-->
<!--     remote-->
<!--     @on-change="onPoiSearchChange"-->
<!--     :remote-method="onSearchPOI"-->
<!--     :loading="searchingPOI"-->
<!--     class="field"-->
<!--     clearable>-->
<!--     <Option v-for="(option, index) in searchPOIResultList" clearable :value="option.name" :key="option.id">{{option.name}}<label-->
<!--      style="color: #cccccc">{{option.district}}</label>-->
<!--     </Option>-->
<!--    </Select>-->

  <Input size="small" v-model="selected" placeholder="搜索点" @on-change="onSearchPOI" @on-enter="onSearchChange" style=" width:200px; position: absolute; top:5px; left: 60px;" clearable/>
  <Button icon="md-sunny" size="small" style="position: absolute; top:5px; left: 270px;" @click="realtimeTraffic">路况</Button>

  <div v-if="showsearchPOI">
  <ul style=" position: absolute; top:35px; left: 60px;width: auto;background-color: #ffffff;border-radius:5px;box-shadow:0 2px 12px 0 rgba(0,0,0,.3);max-height:200px;overflow-y:scroll;z-index: 999">
   <li style="margin: 0;
    line-height: normal;
    padding: 7px 16px;
    clear: both;
    color: #515a6e;
    font-size: 12px !important;
    white-space: nowrap;
    list-style: none;
    cursor: pointer;
    -webkit-transition: background 0.2s ease-in-out;
    transition: background 0.2s ease-in-out;" v-for="item in searchPOIResultList" @click="showSearchPOI(item.name)">{{item.name}}<label style="color: rgb(204, 204, 204);">{{item.district}}</label></li>
<!--   <li>222</li>-->
<!--   <li>333</li>-->
  </ul>
  </div>

  <div v-if="selectedPOI"
       style="position: absolute; top:30px;left: 60px; width: 200px; height: 400px; background: white;">
   <Tabs size="small">
    <TabPane label="地物点" style="overflow:scroll; height: 350px; padding-left: 5px;">
     <div v-for="(item,index) in screenPOIResultList" @click="onScreenPOIItemClick(item,index)">
      <img :src="'/pois/poi_' + (index + 1) + '.png'" style="margin-top: 8px; width: 17px; height: 27px; vertical-align: top;">
      <div style="width: 160px; margin-left: 10px; display: inline-block; margin-top: 5px; ">
       <div style="color: #495060;font-weight:bold;">{{item.name}}</div>
       <div style="color: #cccccc; margin-top: 1px; font-size: 8px;">{{item.address}}</div>
      </div>
      <div style="height: 1px; width: 95%; background: #cccccc; margin-top: 8px;"></div>
     </div>
    </TabPane>
    <TabPane label="自定义点" style="overflow:scroll; height: 350px; padding-left: 5px;">
     <div v-for="(item,index) in screenCustompoiResultList" @click="onScreenCustompoiItemClick(item,index)">
      <!--      <img :src="'/pois/poi_' + (index + 1) + '.png'" style="margin-top: 8px; width: 17px; height: 27px; vertical-align: top;">-->
      <div style="width: 160px; margin-left: 10px; display: inline-block; margin-top: 5px; ">
       <div style="color: #495060;font-weight:bold;">{{item.name}}</div>
       <div style="color: #cccccc; margin-top: 1px; font-size: 8px;">{{item.address}}</div>
      </div>
      <div style="height: 1px; width: 95%; background: #cccccc; margin-top: 8px;"></div>
     </div>
    </TabPane>

    <Button @click="colseselectedPOI" size="small" slot="extra" style="margin-top: 3px;margin-right: 3px">关闭</Button>

   </Tabs>
  </div>

  <!--  <Select-->
  <!--   size="small"-->
  <!--   suffix="ios-search"-->
  <!--   style=" width:200px; position: absolute; top: 35px; left: 60px;"-->
  <!--   placeholder="请输入自定义点名称"-->
  <!--   v-model="selectedCustompoi"-->
  <!--   filterable-->
  <!--   remote-->
  <!--   @on-change="ononCustompoiChange"-->
  <!--   :remote-method="onCustompoi"-->
  <!--   :loading="searchingCustompoi"-->
  <!--   class="field"-->
  <!--   clearable>-->
  <!--   <Option v-for="(option, index) in searchCustompoiResultList" :value="option" :key="option.id">{{option.name}}-->
  <!--   </Option>-->
  <!--  </Select>-->
  <!--  <div v-if="selectedCustompoi"-->
  <!--       style="position: absolute; top:60px;left: 60px; width: 200px; height: 400px; background: white;">-->
  <!--   <Tabs size="small">-->
  <!--    <TabPane label="自定义点" style="overflow:scroll; height: 350px; padding-left: 5px;">-->
  <!--     <div v-for="(item,index) in screenCustompoiResultList" @click="onScreenCustompoiItemClick(item,index)">-->
  <!--      <img :src="'/pois/poi_' + (index + 1) + '.png'" style="margin-top: 8px; width: 17px; height: 27px; vertical-align: top;">-->
  <!--      <div style="width: 160px; margin-left: 10px; display: inline-block; margin-top: 5px; ">-->
  <!--       <div style="color: #495060;font-weight:bold;">{{item.name}}</div>-->
  <!--       <div style="color: #cccccc; margin-top: 1px; font-size: 8px;">{{item.address}}</div>-->
  <!--      </div>-->
  <!--      <div style="height: 1px; width: 95%; background: #cccccc; margin-top: 8px;"></div>-->
  <!--     </div>-->
  <!--    </TabPane>-->
  <!--&lt;!&ndash;    <TabPane label="自定义点">&ndash;&gt;-->

  <!--&lt;!&ndash;    </TabPane>&ndash;&gt;-->
  <!--   </Tabs>-->
  <!--  </div>-->

  <div style="display: inline; width: 40px; position: absolute; top: 5px; right: 5px;">
   <Button type="primary" size="small" @click="onToolsBarBtnClick('区域')">区域</Button>
   <Button type="primary" size="small" style="margin-top: 3px;" @click="onToolsBarBtnClick('工具')">工具</Button>
   <!--   <Button type="primary" size="small" style="margin-top: 3px;" @click="onToolsBarBtnClick('地图')">地图</Button>-->
  </div>

  <div style="display: inline; width: 40px; position: absolute; bottom: 10px; right: 20px;">
   <Button type="success" icon="md-undo" style="margin-top: 3px;" @click="goBack"></Button>

<!--   <Button type="primary" size="small" style="margin-top: 3px;" icon="md-undo" @click="realtimeTraffic"></Button>-->
  </div>

  <div :style="areaToolViewStyle">
   <Select v-model="selectProvince" style="width:150px; position: absolute; top: 5px; right: 60px;"
           @on-change="onProvinceChange">
    <Option v-for="item in provinceList" :value="item.name" :key="item.name">{{ item.name }}</Option>
   </Select>
   <Select v-model="selectCity" style="width:150px; position: absolute; top: 45px; right: 60px;"
           @on-change="onCityChange">
    <Option v-for="item in cityList" :value="item.name" :key="item.name">{{ item.name }}</Option>
   </Select>
  </div>
  <div :style="toolsPackViewStyle">
   <Button type="primary" size="small" style="margin-right: 3px;" @click="onMeasureArea">测面积</Button>
   <Button type="primary" size="small" style="margin-right: 3px;" @click="onMeasureDistance">测距离</Button>
   <Button type="primary" size="small" style="margin-right: 3px;" @click="clearMeasureAreaAndMeasureDistance">清除面积和距离</Button>
   <Button type="primary" size="small" style="margin-right: 3px;" @click="onAddCoustomerPoint">自定义点</Button>
   <Button type="primary" size="small" style="margin-right: 3px;" @click="onShowAndHiddenCoustomerPoint">显示/隐藏自定义点</Button>
   <!--   <Button type="primary" size="small" style="margin-right: 3px;" @click="onOverviewMap">鹰眼</Button>-->
   <Button type="primary" size="small" style="margin-right: 3px;" @click="onReduceTracks">
    {{isReduceTracks==true?'取消简化':'简化轨迹'}}
   </Button>
   <Button type="primary" size="small" style="margin-right: 3px;" @click="onShowMouseLatLng">经纬度</Button>
   <Button type="primary" size="small" style="margin-right: 3px;">绘制路线</Button>
<!--   <Button type="primary" size="small" style="margin-right: 3px;" @click="onroutePolicy">导航</Button>-->
  </div>
  <div v-if="showMouseLatLng"
       style="display: block;left: 3px; bottom: 3px; position: absolute; background: white; padding: 3px 3px 3px 3px;">
   <div>经度:{{mouseLng}}</div>
   <div>纬度:{{mouseLat}}</div>
  </div>
  <!--导航-->
  <!--  <div-->
  <div v-if="showroutePolicy"
       style="display: block;left: 3px; bottom: 48px; position: absolute; background: white; padding: 3px 3px 3px 3px;">
   <div>开始坐标点</div>  <div>经度:{{StartmouseLng}}</div>   <div>纬度:{{StartmouseLat}}</div> <div><Button type="primary" size="small" style="margin-right: 3px;" @click="onShowStartMouseLatLng">获取开始坐标点</Button></div>
   <div>终点坐标点</div>  <div>经度:{{EndmouseLng}}</div>   <div>纬度:{{EndmouseLat}}</div> <div><Button type="primary" size="small" style="margin-right: 3px;" @click="onShowEndMouseLatLng">获取终点坐标点</Button></div>
   <div>
    <Select v-model="tactics" size="small" style="width:100px">
     <Option v-for="item in tacticsList" :value="item.value" :key="item.label">{{ item.label }}</Option>
    </Select>
   </div>
   <div>
    总里程:{{navigationdistance}}公里<br>
    耗时：约{{navigationduration}}
   </div>
   <div><Button type="primary" size="small" style="margin-right: 3px;" @click="onSearchNavigation">搜索路线</Button></div>
   <div><Button type="primary" size="small" style="margin-right: 3px;" @click="onClearSearchNavigation">清除导航</Button></div>
   <!--   <div><Button type="primary" size="small" style="margin-right: 3px;" @click="onStartNavigation">开始导航</Button></div>-->
   <Spin size="large" fix v-if="SpinShow" ></Spin>
  </div>
  <div v-if="showDistance"
       style="display: block;left: 3px; bottom: 348px; position: absolute; background: white; padding: 3px 3px 3px 3px;">
   <div v-for="(item,index) in distancelist">
    <div>第{{index+1}}段:{{item}}</div>
   </div>
   <div>总距离:{{distance}}</div>
  </div>
  <div v-if="showArea"
       style="display: block;left: 3px; bottom: 321px; position: absolute; background: white; padding: 3px 3px 3px 3px;">
   <div>面积:{{area}}</div>
  </div>
  <!-- 工具栏 -->
 </div>
</template>
<script>
import AddCustomerPointModal from '@/view/ddm/components/map-info-windows/add-customer-point-modal'
import CustomerPointDetailModal from '@/view/ddm/components/map-info-windows/customer-point-detail-modal'
import ModifyCustomerPointModal from '@/view/ddm/components/map-info-windows/modify-customer-point-modal'
import VehicleInfoModal from '@/view/ddm/components/map-info-windows/vehicle-info-modal'

import areaDataJson from '@/libs/areadata.js'
import axios from '@/libs/api.request'
import esriLoader from 'esri-loader'

import Vue from 'vue'
import { GPS } from '@/libs/positonUtils'
import store from '@/store'
import { VehicleDymaicManager } from '@/libs/vehicle-dymaic-manager2'
import jcicp from '@/proto/jcicp.js'
import { jcicpEncode, jcicpDecode } from '@/libs/jcicputil.js'
import { registrationTextColor, registrationColor } from '@/libs/registrationutil'
import { FontUtil } from '@/libs/fontutil'
import { isAccOn, explainDirection, explainState, explainAlarmSign } from '@/libs/jt808util'
import { stringToByte } from '@/libs/stringutil'
// import { reqReverseGeocoderDetail, reqReverseGeocoder, reqRegion, reqSearchDirection } from '@/libs/baidumaputil'
import { reqSearchPOI, reqSearchPolygon, reqGDReverseGeocoderDetail } from '@/libs/amaputil'
import { forEach } from '../../../../libs/tools'
function isNanDef (num, def, fix) {
  return (isNaN(num) ? def : num).toFixed(fix)
}
export default {
  name: 'arcgismonitormap',
  props: {
    vehicleDymaicManager: {
      required: true
    },
    onwarn: {
      required: true
    }
  },
  components: {
    AddCustomerPointModal,
    ModifyCustomerPointModal,
    CustomerPointDetailModal,
    VehicleInfoModal
  },
  data () {
    return {
    // 测量距离
      distancelist: [],
      distance: 0,
      showDistance: false,
      // 测量面积
      area: 0,
      showArea: false,

      // 搜索地物点和POI点
      selected: null,
      // 地图模糊搜索
      showsearchPOI: false,

      // POI搜索
      selectedPOI: false,
      searchingPOI: false,
      searchPOIResultList: [],
      screenPOIResultList: [],

      // 地图信息框引用
      addCustomerPointModalRef: null,
      customerPointDetailModalRef: null,
      modifyCustomerPointModalRef: null,
      vehicleInfoModalRef: null,

      // 客户自定义点
      showpoi: false,
      // 自定义点搜索
      selectedCustompoi: null,
      searchingCustompoi: false,
      searchCustompoiResultList: [],
      screenCustompoiResultList: [],

      // 是否简化轨迹
      isReduceTracks: true,

      // 经纬度
      showMouseLatLng: false,
      mouseLat: 0,
      mouseLng: 0,
      leftTop: null,
      rightBottom: null,

      // 导航
      showroutePolicy: false,
      StartMouseLatLng: null,
      StartmouseLat: 0,
      StartmouseLng: 0,
      EndMouseLatLng: null,
      EndmouseLat: 0,
      EndmouseLng: 0,
      alllist: [],
      navigationdistance: 0,
      navigationduration: 0,
      // 导航,loading
      SpinShow: false,

      // 路线信息
      realtimeMarker: null,

      // 导航路线方案,少收费，不走高速等
      tactics: 0,
      tacticsList: [
        {
          value: '0',
          label: '默认'
        },
        {
          value: '2',
          label: '距离最短'
        },
        {
          value: '3',
          label: '不走高速'
        },
        {
          value: '4',
          label: '高速优先'
        },
        {
          value: '5',
          label: '躲避拥堵'
        },
        {
          value: '6',
          label: '少收费'
        }
      ],

      // 鹰眼
      overviewMap: null,

      areaToolViewStyle: {
        display: 'none'
      },
      toolsPackViewStyle: {
        display: 'none',
        position: 'absolute',
        top: '5px',
        right: '60px'
      },

      // 测量面积.长度
      toolbar: null,
      disFun: false,
      areaFun: false,
      customerPointFun: false,
      startFont: null,
      inputPoints: [],
      totalGraphic: null,
      totalDistance: 0,
      totalArea: 0,
      bgGraphic: null,
      vehicleNameGraphic: null,
      deletedistance: null,
      deletedistancelist: [],
      deletedistancelists: [],

      selectProvince: null,
      selectCity: null,
      provinceList: [],
      cityList: [],

      // vehicleDymaicManager数据结构容器 -----------------------------
      // subscribedVehicleInfos:[],  // 已订阅车辆信息列表
      // vehicleInfoHashMap:{},      // 车辆信息哈斯表({key:terminalNum, value:VehicleInfo})

      // 地图元素 --------------------------------
      refreshTaskTimer: null,

      vehicleIconSize: {
        width: 16,
        height: 33
      },

      // 实时路况显示隐藏
      showTraffic: false,

      arcgisElements: {
        vehicleMarkerLayer: null, // 实时车辆图标层
        tracksLayer: null, // 轨迹线层
        poiLayer: null, // 客户自定义点层
        measureLayer: null, // 测量层
        searchPOILayer: null, // 搜索POI显示层
        navigationer: null, // 导航图层
        realtimeTraffic: null, // 实时路况图层
        StreetLayer: null // 市区街道图层
      },
      arcgisModules: {
        pictureMarkerSymbol: null,
        point: null,
        graphic: null,
        webMercatorUtils: null,
        polyline: null,
        cartographicLineSymbol: null,
        arcgisColor: null,
        graphicsLayer: null,
        featureLayer: null,
        textSymbol: null,
        simpleLineSymbol: null,
        simpleMarkerSymbol: null,
        simpleFillSymbol: null,
        font: null,
        toolbarsDraw: null,
        lengthsParameters: null,
        areasAndLengthsParameters: null,
        geometryService: null,
        overviewMap: null
      },
      _map: null, // 主地图组件
      _gdlayer: null,
      _view: null,
      spatialReference: null,
      _maptype: null,
      initialExtent: null,
      tileInfo: null,
      loaded: false,
      mapLoadding: false, //
      _customPOIMarkers: [], // 客户自定义POI点Marker集合
      // currentClickedVehicleInfo: null,

      // 配置参数 ------------------------------------
      webconfig: {
        id: null,
        realtimeAnalyzePosition: false,
        autoLoadTracks: false,
        autoLoadTracksSpan: 180,
        displayRegistration: true
      },
      debugInfo: {
        loadTrackPointCount: 0
      },
      mapInitZoom: false,
      offset: 0.5,
      offsetVertical: 0.85,
      subscribeOffsetVertical: 0.3,
      mapDefaultCenter: null
    }
  },
  methods: {
    showwarn (e, boon) {
      // console.log(e)
      console.log(boon)
      for (let i = 0; i < e.length; i++) {
        let currentClickedVehicleInfo = e[i]

        if (currentClickedVehicleInfo.gis.tracks) {
          currentClickedVehicleInfo.gis.tracks.symbol.color = new this.arcgisModules.arcgisColor('#0000FF')
        }
        if (currentClickedVehicleInfo.gis.realtimeMarker) {
          let symbol = currentClickedVehicleInfo.gis.realtimeMarker.symbol
          let realtimeLocationFrame = currentClickedVehicleInfo.dymaic.realtimeLocationFrame
          if (realtimeLocationFrame.alarm > 0 && boon) {
            // 报警
            symbol.url = '/vehiclealarm.png'
          } else {
            if (currentClickedVehicleInfo.info.terminalState == '离线') {
              symbol.url = '/vehicleoffline.png'
            } else if (currentClickedVehicleInfo.info.terminalState == '停止') {
              symbol.url = '/vehiclestop.png'
            } else if (currentClickedVehicleInfo.info.terminalState == '行驶') {
              symbol.url = '/vehiclerun.png'
            } else if (currentClickedVehicleInfo.info.terminalState == '停车未熄火') {
              symbol.url = '/vehiclenospeed.png'
            } else {
              symbol.url = '/vehicleoffline.png'
            }
          }
          this.vehicleInfoModalRef.onClose()
          this.arcgisElements.vehicleMarkerLayer.redraw()
        }
      }
      // console.log('刷新')
    },
    /** --------------------------------------------------
    * 方法部分
    */

    // ---------- 工具栏 Begin-------------------

    onScreenPOIItemClick (item, index) {
      // console.log(item)
      let v = item.location.split(',')
      let pos = { lat: parseFloat(v[1]), lon: parseFloat(v[0]) }
      let posChange = new this.arcgisModules.point(pos.lon, pos.lat, this._map.spatialReference)
      // 转换成平面投影坐标系
      posChange = this.arcgisModules.webMercatorUtils.geographicToWebMercator(posChange)
      // console.log(posChange)
      this._map.setZoom(18)
      this._map.centerAt(posChange)
    },
    onScreenCustompoiItemClick (item, index) {
      // console.log(item)
      // console.log(index)
      let pos = { lat: item.latitude, lon: item.longitude }
      // console.log(pos)
      let gcpos = GPS.gcj_encrypt(pos.lat, pos.lon)
      let posChange = new this.arcgisModules.point(gcpos.lon, gcpos.lat, this._map.spatialReference)
      // 转换成平面投影坐标系
      posChange = this.arcgisModules.webMercatorUtils.geographicToWebMercator(posChange)
      // console.log(posChange)
      this._map.setZoom(18)
      this._map.centerAt(posChange)
    },

    /**
    * 搜索地物点和POI点
    */
    onSearchChange (item) {
      // console.log(item)
      // console.log(this.selected)
      let keyword = this.selected

      reqSearchPolygon(keyword, this.leftTop, this.rightBottom, (data) => {
        console.log(data)
        if (data.status == '1') {
          this.screenPOIResultList = data.pois
          let v = null
          let pos = null
          this.arcgisElements.searchPOILayer.clear()
          let i = 0
          forEach(this.screenPOIResultList, (p) => {
            v = p.location.split(',')
            // console.log(p.location)
            pos = { lat: parseFloat(v[1]), lon: parseFloat(v[0]) }
            let posChange = new this.arcgisModules.point(pos.lon, pos.lat, this._map.spatialReference)
            // 转换成平面投影坐标系
            posChange = this.arcgisModules.webMercatorUtils.geographicToWebMercator(posChange)
            let iconUrl = '/pois/poi_' + (i + 1) + '.png'
            let searchResultPOIMarker = new this.arcgisModules.pictureMarkerSymbol(iconUrl, 17, 27)
            searchResultPOIMarker = new this.arcgisModules.graphic(posChange, searchResultPOIMarker, {
              markerType: 'searchResultPOIMarker' + (i + 1)
            }, null)
            this.arcgisElements.searchPOILayer.add(searchResultPOIMarker)
            i++
          })
        }
        this.showsearchPOI = false
      })

      store.dispatch('CustomPOIServ_GetMyPage', {
        params: null,
        urlparams: {
          keyword: keyword
        }
      }).then(res => {
        // console.log(res)
        this.screenCustompoiResultList = res.data.content
        this.showsearchPOI = false
      }).catch(err => {
        console.log(err)
      })
      this.selectedPOI = true
      if (this.selected == null) {
        this.showsearchPOI = false
      }
    },

    colseselectedPOI () {
      this.selectedPOI = false
      this.arcgisElements.searchPOILayer.clear()
    },

    /**
    * 搜索地物点
    */
    showSearchPOI (e) {
      this.selectedPOI = true
      // console.log(e)
      this.selected = e
      this.onSearchChange(e)
      this.showsearchPOI = false
    },
/*    onPoiSearchChange (item) {
      if (item) {
        // console.log(item)
        reqSearchPolygon(item, this.leftTop, this.rightBottom, (data) => {
          // console.log(data)
          if (data.status == '1') {
            let v = null
            let pos = null
            this.screenPOIResultList = data.pois
            this.arcgisElements.searchPOILayer.clear()
            let i = 0
            forEach(this.screenPOIResultList, (p) => {
              v = p.location.split(',')
              // console.log(p.location)
              pos = { lat: parseFloat(v[1]), lon: parseFloat(v[0]) }
              let posChange = new this.arcgisModules.point(pos.lon, pos.lat, this._map.spatialReference)
              // 转换成平面投影坐标系
              posChange = this.arcgisModules.webMercatorUtils.geographicToWebMercator(posChange)
              let iconUrl = '/pois/poi_' + (i + 1) + '.png'
              let searchResultPOIMarker = new this.arcgisModules.pictureMarkerSymbol(iconUrl, 17, 27)
              searchResultPOIMarker = new this.arcgisModules.graphic(posChange, searchResultPOIMarker, {
                markerType: 'searchResultPOIMarker' + (i + 1)
              }, null)
              this.arcgisElements.searchPOILayer.add(searchResultPOIMarker)
              i++
            })
          }
        })
      } else {
        console.log('清空')
        this.arcgisElements.searchPOILayer.clear()
      }
    },*/

    onSearchPOI (keyword) {
      if (this.selected == null || this.selected == '') {
        this.arcgisElements.searchPOILayer.clear()
      }
      this.showsearchPOI = true
      if (!this.selected) {
        this.showsearchPOI = false
        this.selectedPOI = false
      }
      keyword = this.selected
      // console.log(keyword)
      this.searchingPOI = true
      this.searchPOIResultList = []
      let pos = this._map.toMap(this._map.position)
      let level = this._map.getLevel()
      let pres = Math.min(6, level)
      let v = this.arcgisModules.webMercatorUtils.xyToLngLat(pos.x.toFixed(pres), pos.y.toFixed(pres))
      pos = GPS.gcj_decrypt(v[1], v[0])
      // console.log(pos)
      reqSearchPOI(keyword, pos, (data) => {
        // console.log(data)
        if (data.status == 1) {
          this.searchPOIResultList = data.tips
          store.dispatch('CustomPOIServ_GetMyPage', {
            params: null,
            urlparams: {
              keyword: keyword
            }
          }).then(res => {
            // console.log(res)
            res.data.content.forEach(item => {
              this.searchPOIResultList.push(item)
              this.screenCustompoiResultList = res.data.content
            })
          }).catch(err => {
            console.log(err)
          })
        }

        console.log(this.searchPOIResultList)

        this.searchingPOI = false
      })
    },
    /**
    * 搜索客户自定义点
    */
    ononCustompoiChange (item) {
      // console.log(item)
      // store.dispatch('CustomPOIServ_GetDetail', {
      //   params: {
      //     id: item
      //   },
      store.dispatch('CustomPOIServ_GetMyPage', {
        params: null,
        urlparams: {
          keyword: item.name
        }
      }).then(res => {
        // console.log(res)
        this.screenCustompoiResultList = res.data.content
        // let pos = { lat: res.data.latitude, lon: res.data.longitude }
        // // console.log(pos)
        // let posChange = new this.arcgisModules.point(pos.lon, pos.lat, this._map.spatialReference)
        // // 转换成平面投影坐标系
        // posChange = this.arcgisModules.webMercatorUtils.geographicToWebMercator(posChange)
        // // console.log(posChange)
        // this._map.centerAt(posChange)
      }).catch(err => {
        console.log(err)
      })
    },
    onCustompoi (keyword) {
      this.searchingCustompoi = true
      this.searchCustompoiResultList = []
      let pos = this._map.toMap(this._map.position)
      let level = this._map.getLevel()
      let pres = Math.min(6, level)
      let v = this.arcgisModules.webMercatorUtils.xyToLngLat(pos.x.toFixed(pres), pos.y.toFixed(pres))
      pos = GPS.gcj_decrypt(v[1], v[0])
      // console.log(pos)
      store.dispatch('CustomPOIServ_GetMyAll', {
        params: null,
        urlparams: {
          keyword: keyword
        }
      }).then(res => {
        // console.log(res)
        this.searchCustompoiResultList = res.data
        this.searchingCustompoi = false
      }).catch(err => {
        console.log(err)
      })
    },

    onToolsBarBtnClick (e) {
      if (e == '区域') {
        this.toolsPackViewStyle.display = 'none'
        if (this.areaToolViewStyle.display == 'none') {
          this.areaToolViewStyle.display = 'block'
        } else {
          this.areaToolViewStyle.display = 'none'
        }
      } else if (e == '工具') {
        this.areaToolViewStyle.display = 'none'
        if (this.toolsPackViewStyle.display == 'none') {
          this.toolsPackViewStyle.display = 'block'
        } else {
          this.toolsPackViewStyle.display = 'none'
        }
      } else if (e == '地图') {
        this.areaToolViewStyle.display = 'none'
      }
    },

    /**
    * 选择省
    */
    onProvinceChange (provinceName) {
      for (let i = 0; i < this.provinceList.length; i++) {
        if (this.provinceList[i].name == provinceName) {
          this.cityList = this.provinceList[i].districts
          let posChange = this.aMapToScreenPoint(this.provinceList[i].center.latitude, this.provinceList[i].center.longitude)
          this._map.centerAt(posChange)
          break
        }
      }
    },

    /**
    * 选择市
    */
    onCityChange (cityName) {
      for (let i = 0; i < this.cityList.length; i++) {
        if (this.cityList[i].name == cityName) {
          let posChange = this.aMapToScreenPoint(this.cityList[i].center.latitude, this.cityList[i].center.longitude)
          this._map.centerAt(posChange)
          break
        }
      }
    },

    // 量算函数
    onMeasureMapClick (evt) {
      if (this.disFun) {
        this.inputPoints.push(evt.mapPoint)
        if (!this.measureMakerSymbol) {
          this.measureMakerSymbol = new this.arcgisModules.simpleMarkerSymbol()
        }
        if (!this.startFont) {
          this.startFont = new this.arcgisModules.font()
        }
        let textSymbol
        if (this.inputPoints.length === 1) {
          textSymbol = new this.arcgisModules.textSymbol('起点', this.startFont, new this.arcgisModules.arcgisColor([204, 102, 51]))
          textSymbol.setOffset(0, -20)
          let startingSymbol = new this.arcgisModules.graphic(evt.mapPoint, textSymbol, {
            deletedistanceId: this.deletedistancelists.length,
            markerType: 'deletedistance'
          })
          this.arcgisElements.measureLayer.add(startingSymbol)
          this.deletedistancelist.push(startingSymbol)
          this.bgGraphic = null
          this.vehicleNameGraphic = null
          this.deletedistance = null
        }
        this.measureMakerSymbol.setSize(7)
        this.measureMakerSymbol.setColor(new this.arcgisModules.arcgisColor('#00fa32'))
        let measureMakerSymbol = new this.arcgisModules.graphic(evt.mapPoint, this.measureMakerSymbol, {
          deletedistanceId: this.deletedistancelists.length,
          markerType: 'deletedistance'
        })
        this.arcgisElements.measureLayer.add(measureMakerSymbol)
        this.deletedistancelist.push(measureMakerSymbol)
        if (this.inputPoints.length >= 2) {
          //    设置距离测量的参数
          let lengthParams = new this.arcgisModules.lengthsParameters()
          lengthParams.distanceUnit = this.arcgisModules.geometryService.UNIT_METER
          lengthParams.calculationType = 'preserveShape'
          let p1 = this.inputPoints[this.inputPoints.length - 2]
          let p2 = this.inputPoints[this.inputPoints.length - 1]
          if (p1.x === p2.x && p1.y === p2.y) {
            return
          }
          //    z在两点之间划线将两点链接起来
          let polyline = new this.arcgisModules.polyline(this._map.spatialReference)
          polyline.addPath([p1, p2])
          lengthParams.polylines = [polyline]
          // 根据参数，动态的计算长度
          this.arcgisElements.geometryService.lengths(lengthParams, (distance) => {
            // let _distance = number.format(distance.lengths[0] / 1000)
            let _distance = Number(distance.lengths[0])
            this.totalDistance += parseFloat(_distance)// 计算总长度
            // let beetwentDistances = isNanDef(_distance, 0, 2) + '千米'
            // this.distancelist.push(beetwentDistances)
            // let tdistance = new this.arcgisModules.textSymbol(beetwentDistances, this.startFont, new this.arcgisModules.arcgisColor([204, 102, 51]))
            // tdistance.setOffset(40, -3)
            // this.arcgisElements.measureLayer.add(new this.arcgisModules.graphic(p2, tdistance))
            // if (this.totalGraphic) {
            //   this.arcgisElements.measureLayer.remove(this.totalGraphic)
            // }
            // let total = Number.FormatNumber(this.totalDistance, {
            //   pattern: "#.000"
            // });
            // let total = this.totalDistance
            // this.distance = isNanDef(total, 0, 2) + '千米'
            // //    设置总长度的显示样式，并添加到地图上
            // let totalSymbol = new this.arcgisModules.textSymbol('总长度：' + isNanDef(total, 0, 2) + '千米', this.startFont, new this.arcgisModules.arcgisColor([204, 102, 51]))
            // totalSymbol.setOffset(40, -15)
            // this.totalGraphic = this.arcgisElements.measureLayer.add(new this.arcgisModules.graphic(p2, totalSymbol))

            // 显示测距离分段长度
            FontUtil.init(9, 'Arial')
            let bgColor = new this.arcgisModules.arcgisColor('#ffffff')
            let fontColor = new this.arcgisModules.arcgisColor('#000000')
            let font = new this.arcgisModules.font({ size: 9, family: 'Arial' })
            // let vehicleName = isNanDef(_distance, 0, 2) + '米'
            let vehicleName = null
            if (this.totalDistance < 1000) {
              vehicleName = isNanDef(this.totalDistance, 0, 2) + '米'
            } else {
              vehicleName = isNanDef(this.totalDistance / 1000, 0, 2) + '公里'
            }
            var bglineSymbol = new this.arcgisModules.simpleLineSymbol('solid', fontColor, 0.5)
            // let vehicleNameLength = stringToByte(vehicleName).length
            let sizeD = FontUtil.computeFontSize(vehicleName)
            var width = sizeD.width + 6
            var height = sizeD.height + 2
            var path = 'M0 ' + height + 'L' + width + ' ' + height + 'L' + width + ' 0L0 0Z'
            var bgSymbol = new this.arcgisModules.simpleMarkerSymbol()
            bgSymbol.setPath(path)
            bgSymbol.setOffset(0, 0 - this.vehicleIconSize.height - (font.size / 2) + 18)
            bgSymbol.setColor(bgColor)
            bgSymbol.setOutline(bglineSymbol)
            // 这个size很重要，边框大小的上限取决于size
            var size = Math.max(height, width)
            bgSymbol.setSize(size)
            // 12635715.327720843, 2578665.6237879856
            // var bgGraphic = new this.arcgisModules.graphic( new this.arcgisModules.point(12635715.327720843,2578665.6237879856, this._map.spatialReference), bgSymbol)
            var bgGraphic = new this.arcgisModules.graphic(p2, bgSymbol, {
              deletedistanceId: this.deletedistancelists.length,
              markerType: 'deletedistance'
            })
            // bgSymbol.yoffset = this._offsetY;
            this.arcgisElements.measureLayer.add(bgGraphic)
            this.deletedistancelist.push(bgGraphic)
            var vehicleNameSymbol = new this.arcgisModules.textSymbol(vehicleName, font, fontColor)
            // symbol.yoffset = -(font.size / 2) + 31//+ this._offsetY;
            vehicleNameSymbol.yoffset = 0 - this.vehicleIconSize.height - font.size + 19
            // var vehicleNameGraphic = new this.arcgisModules.graphic(new this.arcgisModules.point(12635715.327720843,2578665.6237879856, this._map.spatialReference), vehicleNameSymbol, {})
            var vehicleNameGraphic = new this.arcgisModules.graphic(p2, vehicleNameSymbol, {
              deletedistanceId: this.deletedistancelists.length,
              markerType: 'deletedistance'
            })
            this.arcgisElements.measureLayer.add(vehicleNameGraphic)
            this.deletedistancelist.push(vehicleNameGraphic)

            // this.nameLabel = { vehicleNameText: vehicleNameGraphic, vehicleNameBg: bgGraphic }
            FontUtil.deInit()

            if (this.bgGraphic) {
              this.arcgisElements.measureLayer.remove(this.bgGraphic)
            }
            if (this.vehicleNameGraphic) {
              this.arcgisElements.measureLayer.remove(this.vehicleNameGraphic)
            }
            if (this.deletedistance) {
              this.arcgisElements.measureLayer.remove(this.deletedistance)
            }
            // 显示测距离总长度
            FontUtil.init(9, 'Arial')
            vehicleName = '总长度：' + isNanDef(this.totalDistance / 1000, 0, 2) + '公里'
            var bglineSymbol = new this.arcgisModules.simpleLineSymbol('solid', fontColor, 0.5)
            // let vehicleNameLength = stringToByte(vehicleName).length
            sizeD = FontUtil.computeFontSize(vehicleName)
            var width = sizeD.width + 6
            var height = sizeD.height + 2
            var path = 'M0 ' + height + 'L' + width + ' ' + height + 'L' + width + ' 0L0 0Z'
            var bgSymbol = new this.arcgisModules.simpleMarkerSymbol()
            bgSymbol.setPath(path)
            bgSymbol.setOffset(0, 0 - this.vehicleIconSize.height - (font.size / 2) + (-2))
            bgSymbol.setColor(bgColor)
            bgSymbol.setOutline(bglineSymbol)
            // 这个size很重要，边框大小的上限取决于size
            var size = Math.max(height, width)
            bgSymbol.setSize(size)
            // 12635715.327720843, 2578665.6237879856
            // var bgGraphic = new this.arcgisModules.graphic( new this.arcgisModules.point(12635715.327720843,2578665.6237879856, this._map.spatialReference), bgSymbol)
            if (this.inputPoints.length === 1) {
            }
            var bgGraphic = new this.arcgisModules.graphic(p2, bgSymbol, {
              deletedistanceId: this.deletedistancelists.length,
              markerType: 'deletedistance'
            })
            this.bgGraphic = bgGraphic
            // bgSymbol.yoffset = this._offsetY;
            this.arcgisElements.measureLayer.add(bgGraphic)
            this.deletedistancelist.push(bgGraphic)

            var vehicleNameSymbol = new this.arcgisModules.textSymbol(vehicleName, font, fontColor)
            // symbol.yoffset = -(font.size / 2) + 31//+ this._offsetY;
            vehicleNameSymbol.yoffset = 0 - this.vehicleIconSize.height - font.size + (-1)
            // var vehicleNameGraphic = new this.arcgisModules.graphic(new this.arcgisModules.point(12635715.327720843,2578665.6237879856, this._map.spatialReference), vehicleNameSymbol, {})
            var vehicleNameGraphic = new this.arcgisModules.graphic(p2, vehicleNameSymbol, {
              deletedistanceId: this.deletedistancelists.length,
              markerType: 'deletedistance'
            })
            this.vehicleNameGraphic = vehicleNameGraphic
            this.arcgisElements.measureLayer.add(vehicleNameGraphic)
            this.deletedistancelist.push(vehicleNameGraphic)
            let deletedistance = new this.arcgisModules.pictureMarkerSymbol({
              url: '/delete.jpg',
              width: 10,
              height: 10,
              yoffset: 0,
              xoffset: 15
            })
            let logoGraphic = new this.arcgisModules.graphic(p2, deletedistance, {
              deletedistanceId: this.deletedistancelists.length,
              markerType: 'deletedistance'
            })
            this.deletedistance = logoGraphic
            this.arcgisElements.measureLayer.add(logoGraphic)
            this.deletedistancelist.push(logoGraphic)
            // this.nameLabel = { vehicleNameText: vehicleNameGraphic, vehicleNameBg: bgGraphic }
            FontUtil.deInit()
          })
        }
      }
    },

    /** -----------------------------------------------------
    * 导航
    */
    onroutePolicy () {
      if (this.showroutePolicy) {
        this.showroutePolicy = false
      } else {
        this.showroutePolicy = true
      }
    },

    /** --------------------------------------------------
    * 鹰眼
    */
    onOverviewMap () {
      if (!this.overviewMap) {
        // console.log(this.arcgisModules.overviewMap)
        this.overviewMap = new this.arcgisModules.overviewMap({
          map: this._map, // 必要的
          baseLayer: this._gdlayer
          // visible: true,    // 初始化可见，默认为false
          // attachTo: "bottom-right",    // 默认右上角
          // width: 150,    // 默认值是地图高度的 1/4th
          // height: 150, // 默认值是地图高度的 1/4th
          // opacity: 0.40,     // 透明度    默认0.5
          // maximizeButton: true,    // 最大化,最小化按钮，默认false
          // expandFactor: 3,    //概览地图和总览图上显示的程度矩形的大小之间的比例。默认值是2，这意味着概览地图将至少是两倍的大小的程度矩形。
          // color: "red"    // 默认颜色为#000000
        })
      }
      this.overviewMap.startup()
    },

    /** --------------------------------------------------
    * 经纬度
    */
    onShowMouseLatLng () {
      if (this.showMouseLatLng) {
        this.showMouseLatLng = false
      } else {
        this.showMouseLatLng = true
      }
    },

    /** --------------------------------------------------
    * 导航经纬度
    */
    // 清除导航路线
    onClearSearchNavigation () {
      this.navigationdistance = 0
      this.navigationduration = 0
      if (this.realtimeMarker != null) {
        this.arcgisElements.navigationer.clear()
        this.alllist = []
        this.StartmouseLat = 0
        this.StartmouseLng = 0
        this.EndmouseLat = 0
        this.EndmouseLng = 0
      }
    },
    onShowStartMouseLatLng () {
      this.navigationdistance = 0
      this.navigationduration = 0
      if (this.realtimeMarker != null) {
        this.arcgisElements.navigationer.clear()
        this.StartmouseLat = 0
        this.StartmouseLng = 0
        this.EndmouseLat = 0
        this.EndmouseLng = 0
      }
      if (this.StartMouseLatLng) {
        this.StartMouseLatLng = false
      } else {
        this.StartMouseLatLng = true
      }
    },
    onShowEndMouseLatLng () {
      this.navigationdistance = 0
      this.navigationduration = 0
      // this.EndmouseLat=0
      // this.EndmouseLng=0
      if (this.realtimeMarker != null) {
        // this.arcgisElements.navigationer.clear()
      }
      if (this.EndMouseLatLng) {
        this.EndMouseLatLng = false
      } else {
        this.EndMouseLatLng = true
      }
    },
/*
    // 搜索路线
    onSearchNavigation () {
      this.SpinShow = true

      this.alllist = []
      this.arcgisElements.navigationer.clear()

      let startImg = new this.arcgisModules.pictureMarkerSymbol({ 'url': '/start.png', 'height': 20, 'width': 18, 'yoffset': 10 })
      let endImg = new this.arcgisModules.pictureMarkerSymbol({ 'url': '/end.png', 'height': 20, 'width': 18, 'yoffset': 10 })

      // 起点标识graphic
      if (this.StartmouseLng != 0) {
        let startPoint = new this.arcgisModules.point(this.StartmouseLng, this.StartmouseLat)
        let startGraphic = new this.arcgisModules.graphic(startPoint, startImg, {}, null)
        this.arcgisElements.navigationer.add(startGraphic)
      }

      // 终点标识graphic
      if (this.EndmouseLng != 0) {
        let endPoint = new this.arcgisModules.point(this.EndmouseLng, this.EndmouseLat)
        let endGraphic = new this.arcgisModules.graphic(endPoint, endImg, {}, null)
        this.arcgisElements.navigationer.add(endGraphic)
      }

      let startpos = GPS.gcj_encrypt(this.StartmouseLat, this.StartmouseLng)
      let startbdpos = GPS.bd_encrypt(this.StartmouseLat, this.StartmouseLng)
      let startlonlat = [startbdpos.lat, startbdpos.lon]

      let endpos = GPS.gcj_encrypt(this.EndmouseLat, this.EndmouseLng)
      let endbdpos = GPS.bd_encrypt(this.EndmouseLat, this.EndmouseLng)
      let endlonlat = [endbdpos.lat, endbdpos.lon]

      let list = []
      reqSearchDirection(startlonlat, endlonlat, this.tactics, res => {
        // console.log(res)
        // console.log(res.result.routes[0].steps)
        list = res.result.routes[0].steps
        // 导航距离
        this.navigationdistance = res.result.routes[0].distance / 1000
        // 导航时间
        // this.navigationduration = isNanDef(res.result.routes[0].duration / 3600, 0, 2)
        let leave1 = (res.result.routes[0].duration * 1000)
        let hours = Math.floor(leave1 / (3600 * 1000))
        // 计算相差分钟数
        let leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
        let minutes = Math.floor(leave2 / (60 * 1000))
        // 计算相差秒数
        let leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
        let seconds = Math.round(leave3 / 1000)
        let result = ''
        if (hours > 0) {
          result += hours + '小时'
        }
        if (minutes > 0) {
          result += minutes + '分'
        }
        // if(seconds > 0){
        //   result += seconds + '秒'
        // }
        this.navigationduration = result
        list.forEach(item => {
          // JSON.parse(item.path)
          // console.log(item.path)

          let listData = item.path.split(';')
          // console.log(listData)
          listData.forEach(listitem => {
            this.alllist.push({
              longitude: listitem.split(',')[0],
              latitude: listitem.split(',')[1]
            })
          })
        })
        // console.log(alllist)
      })
      let that = this
      setTimeout(function () {
        that.onStartNavigation()
      }
        , 500
      )
    },

    onStartNavigation () {
    // 驾车导航
      this.draw()
      this.arcgisElements.navigationer.redraw()
      this.SpinShow = false
    },

    // 绘制导航线
    draw () {
      let content = this.alllist
      let posChange = []
      let start
      let end
      let centerPoint
      let range = null
      content.map((value, index) => {
        // console.log(value)
        // console.log(value.latitude)
        // console.log(value.longitude)
        let p = this.abdMapToScreenPoint(value.latitude, value.longitude)
        // console.log(p)

        posChange.push([p.x, p.y])
        this.drawLine(p)
        // if (index === content.length - 1) {
        //  // centerPoint = {
        //  //  longitude: posChange[Math.round(content.length / 2)][0],
        //  //  latitude: posChange[Math.round(content.length / 2)][1]
        //  // }
        //  end = {
        //   longitude: posChange[content.length - 1][0],
        //   latitude: posChange[content.length - 1][1]
        //  }
        //  start = {
        //   longitude: posChange[0][0],
        //   latitude: posChange[0][1]
        //  }
        //  range = (content[content.length - 1].mileage - content[0].mileage) / 10
        // }
      })
    // let latLongPoint = new this.arcgisModules.point(centerPoint.longitude, centerPoint.latitude, this._map.spatialReference)
    // this._map.centerAndZoom(latLongPoint, this.zoomLevel(range))
    },
    drawLine (posChange) {
    /!**
     * 行车路线样式
     *!/
      if (this.realtimeMarker) {
        let paths = this.realtimeMarker.geometry.paths[0]
        this.realtimeMarker.geometry.insertPoint(0, paths.length, posChange)
        let lineSymbol = new this.arcgisModules.cartographicLineSymbol(
          this.arcgisModules.cartographicLineSymbol.STYLE_SOLID,
          new this.arcgisModules.arcgisColor('#7f00e2'), 3,
          this.arcgisModules.cartographicLineSymbol.CAP_ROUND,
          this.arcgisModules.cartographicLineSymbol.JOIN_MITER, 5
        )
        // 行车路线graphic
        let trackLine = new this.arcgisModules.graphic(
          new this.arcgisModules.polyline({
            spatialReference: this._map.spatialReference,
            // paths: [[[125, 25],[126, 26]]]
            paths: [[[posChange.x, posChange.y]]]
          }),
          lineSymbol,
          {},
          null
        )
        this.realtimeMarker = trackLine
        this.arcgisElements.navigationer.add(trackLine)
      } else {
        let lineSymbol = new this.arcgisModules.cartographicLineSymbol(
          this.arcgisModules.cartographicLineSymbol.STYLE_SOLID,
          new this.arcgisModules.arcgisColor('#7f00e2'), 3,
          this.arcgisModules.cartographicLineSymbol.CAP_ROUND,
          this.arcgisModules.cartographicLineSymbol.JOIN_MITER, 5
        )
        // 行车路线graphic
        let trackLine = new this.arcgisModules.graphic(
          new this.arcgisModules.polyline({
            spatialReference: this._map.spatialReference,
            // paths: [[[125, 25],[126, 26]]]
            paths: [[[posChange.x, posChange.y]]]
          }),
          lineSymbol,
          {},
          null
        )
        this.realtimeMarker = trackLine
        this.arcgisElements.navigationer.add(trackLine)
      }
    },
*/

    /** --------------------------------------------------
    * 关闭自定义点信息框
    */
    onCloseCustomerPointWindow () {
      let customerPointWindow = document.getElementById('customerPointWindow')
      customerPointWindow.style.display = 'none'
      this.customerPointWindowData.isShow = false
    },

    /** --------------------------------------------------
    * 简化轨迹
    */
    onReduceTracks () {
      this.isReduceTracks = !this.isReduceTracks
      if (this.isReduceTracks) {

      }
    },

    /** --------------------------------------------------
    * 显示或隐藏自定义点
    */
    onShowAndHiddenCoustomerPoint () {
      if (this.showpoi) {
        console.log('隐藏POI')
        this.showpoi = false
        this.arcgisElements.poiLayer.hide()
      } else {
        console.log('显示POI')
        this.showpoi = true
        this.arcgisElements.poiLayer.show()
      }
    },
    /** --------------------------------------------------
    * 添加自定义点
    */
    onAddCoustomerPoint () {
      if (this.customerPointFun) {
        this.customerPointFun = false
        this.toolbar.deactivate()
      } else {
        this.customerPointFun = true
        this.toolbar.activate(this.arcgisModules.toolbarsDraw.POINT)
      }
      this.areaFun = false
      this.disFun = false
    },
    /** --------------------------------------------------
    * 清除距离、面积
    */
    clearMeasureAreaAndMeasureDistance () {
      this.arcgisElements.measureLayer.clear()
      this.distance = 0
      this.area = 0
      this.distancelist = []
      this.disFun = false
      this.areaFun = false
      this.toolbar.deactivate()
      this.customerPointFun = false
      this.showDistance = false
      this.showArea = false
    },
    /** --------------------------------------------------
    * 测量距离
    */
    onMeasureDistance () {
      if (this.showDistance) {
        this.showDistance = false
      } else {
        this.showDistance = true
        this.showArea = false
      }

      if (this.disFun) {
        this.disFun = false
        this.toolbar.deactivate()
      } else {
        this.disFun = true
        this.toolbar.activate(this.arcgisModules.toolbarsDraw.POLYLINE)
      }
      this.areaFun = false
      this.customerPointFun = false
    },

    /** --------------------------------------------------
    * 测量面积
    */
    onMeasureArea () {
      if (this.showArea) {
        this.showArea = false
      } else {
        this.showArea = true
        this.showDistance = false
      }

      if (this.areaFun) {
        this.areaFun = false
        this.toolbar.deactivate()
      } else {
        this.areaFun = true
        this.toolbar.activate(this.arcgisModules.toolbarsDraw.POLYGON)
      }
      this.disFun = false
      this.customerPointFun = false
    },

    createToolbar () {
      if (!this.arcgisElements.geometryService) {
        this.arcgisElements.geometryService = new this.arcgisModules.geometryService('https://utility.arcgisonline.com/ArcGIS/rest/services/Geometry/GeometryServer')
      }
      this.toolbar = new this.arcgisModules.toolbarsDraw(this._map)
      this.toolbar.on('draw-end', this.addToMap)
    },

    addToMap (evt) {
      if (this.disFun || this.areaFun || this.customerPointFun) {
        let geometry = evt.geometry// 绘制图形的geometry
        // 将绘制的图形添加到地图上去
        let symbol = null
        switch (geometry.type) {
          case 'point':
            if (this.customerPointFun) {
              let addCustomerPointModalRef = this.$refs.addCustomerPointModalRef
              addCustomerPointModalRef.showModal(this._map, this.arcgisModules, geometry.x, geometry.y)
              this.toolbar.deactivate()
            } else {
              symbol = new this.arcgisModules.simpleMarkerSymbol(this.arcgisModules.simpleMarkerSymbol.STYLE_CIRCLE, 10,
                new this.arcgisModules.simpleLineSymbol(this.arcgisModules.simpleLineSymbol.STYLE_SOLID, new this.arcgisModules.arcgisColor([255, 0, 0]), 1),
                new this.arcgisModules.arcgisColor([0, 255, 0, 0.25]))
            }
            break
          case 'polyline':
            symbol = new this.arcgisModules.simpleLineSymbol(this.arcgisModules.simpleLineSymbol.STYLE_SOLID,
              new this.arcgisModules.arcgisColor([255, 0, 0, 0.8]), 2)
            break
          case 'polygon':
            symbol = new this.arcgisModules.simpleFillSymbol(this.arcgisModules.simpleFillSymbol.STYLE_SOLID,
              new this.arcgisModules.simpleLineSymbol(this.arcgisModules.simpleLineSymbol.STYLE_SOLID, new this.arcgisModules.arcgisColor([255, 0, 0]), 2),
              new this.arcgisModules.arcgisColor([255, 255, 0, 0.25]))
            break
          case 'extent':
            symbol = new this.arcgisModules.simpleFillSymbol(this.arcgisModules.simpleFillSymbol.STYLE_SOLID,
              new this.arcgisModules.simpleLineSymbol(this.arcgisModules.simpleLineSymbol.STYLE_SOLID, new this.arcgisModules.arcgisColor([255, 0, 0]), 2),
              new this.arcgisModules.arcgisColor([255, 255, 0, 0.25]))
            break
        }
        if (symbol) {
          if (geometry.type == 'polyline') {
            let polylinesymbol = new this.arcgisModules.graphic(geometry, symbol, {
              eletedistanceId: this.deletedistancelists.length - 1,
              markerType: 'deletedistance'
            })
            this.arcgisElements.measureLayer.add(polylinesymbol)
            this.deletedistancelists[this.deletedistancelists.length - 1].push(polylinesymbol)
          } else {
            this.arcgisElements.measureLayer.add(new this.arcgisModules.graphic(geometry, symbol))
          }
        }
        if (this.disFun) {
          this.inputPoints.splice(0, this.inputPoints.length)// 删除数组中的所有元素
          this.totalDistance = 0.0
          this.totalGraphic = null
        } else if (this.areaFun) {
          // 设置面积和长度的参数
          let areasAndLengthsParameters = new this.arcgisModules.areasAndLengthsParameters()
          areasAndLengthsParameters.lengthUnit = this.arcgisModules.geometryService.UNIT_METER// 设置距离单位
          areasAndLengthsParameters.areaUnit = this.arcgisModules.geometryService.UNIT_SQUARE_KILOMETERS// 设置面积单位
          this.arcgisElements.geometryService.simplify([geometry], (simplifiedGeometries) => {
            areasAndLengthsParameters.polygons = simplifiedGeometries
            this.arcgisElements.geometryService.areasAndLengths(areasAndLengthsParameters, (result) => {
              this.area = isNanDef(result.areas[0], 0, 2) + '平方公里'
              // let font = new this.arcgisModules.font('16px', this.arcgisModules.font.STYLE_NORMAL, this.arcgisModules.font.VARIANT_NORMAL, this.arcgisModules.font.WEIGHT_BOLDER)
              // let areaResult = new this.arcgisModules.textSymbol(isNanDef(result.areas[0], 0, 2) + '平方公里', font, new this.arcgisModules.arcgisColor([204, 102, 51]))
              let spoint = new this.arcgisModules.point(geometry.getExtent().getCenter().x, geometry.getExtent().getCenter().y, this._map.spatialReference)
              // this.arcgisElements.measureLayer.add(new this.arcgisModules.graphic(spoint, areaResult))// 在地图上显示测量的面积

              // 测面积大小
              FontUtil.init(9, 'Arial')
              let bgColor = new this.arcgisModules.arcgisColor('#ffffff')
              let fontColor = new this.arcgisModules.arcgisColor('#000000')
              let font = new this.arcgisModules.font({ size: 9, family: 'Arial' })
              let vehicleName = isNanDef(result.areas[0], 0, 2) + '平方公里'
              var bglineSymbol = new this.arcgisModules.simpleLineSymbol('solid', fontColor, 0.5)
              // let vehicleNameLength = stringToByte(vehicleName).length
              let sizeD = FontUtil.computeFontSize(vehicleName)
              var width = sizeD.width + 6
              var height = sizeD.height + 2
              var path = 'M0 ' + height + 'L' + width + ' ' + height + 'L' + width + ' 0L0 0Z'
              var bgSymbol = new this.arcgisModules.simpleMarkerSymbol()
              bgSymbol.setPath(path)
              bgSymbol.setOffset(0, 0 - this.vehicleIconSize.height - (font.size / 2) + 38)
              bgSymbol.setColor(bgColor)
              bgSymbol.setOutline(bglineSymbol)
              // 这个size很重要，边框大小的上限取决于size
              var size = Math.max(height, width)
              bgSymbol.setSize(size)
              // 12635715.327720843, 2578665.6237879856
              // var bgGraphic = new this.arcgisModules.graphic( new this.arcgisModules.point(12635715.327720843,2578665.6237879856, this._map.spatialReference), bgSymbol)
              var bgGraphic = new this.arcgisModules.graphic(spoint, bgSymbol)
              // bgSymbol.yoffset = this._offsetY;
              this.arcgisElements.measureLayer.add(bgGraphic)
              var vehicleNameSymbol = new this.arcgisModules.textSymbol(vehicleName, font, fontColor)
              // symbol.yoffset = -(font.size / 2) + 31//+ this._offsetY;
              vehicleNameSymbol.yoffset = 0 - this.vehicleIconSize.height - font.size + 39
              // var vehicleNameGraphic = new this.arcgisModules.graphic(new this.arcgisModules.point(12635715.327720843,2578665.6237879856, this._map.spatialReference), vehicleNameSymbol, {})
              var vehicleNameGraphic = new this.arcgisModules.graphic(spoint, vehicleNameSymbol, {})
              this.arcgisElements.measureLayer.add(vehicleNameGraphic)
              // this.nameLabel = { vehicleNameText: vehicleNameGraphic, vehicleNameBg: bgGraphic }
              FontUtil.deInit()
            })
          })
        }
      }
      if (this.disFun) {
        this.onMeasureDistance()
      }
      if (this.areaFun) {
        this.onMeasureArea()
      }
    },

    // ---------- 工具栏 End-------------------
    /**
    * 清除轨迹
    */
    onvehicletracksLayer (vehicleInfos) {
      vehicleInfos.forEach(vehicleInfo => {
        if (this.arcgisElements.tracksLayer && vehicleInfo.gis.tracks) {
          vehicleInfo.gis.tracks.geometry.paths[0] = []
        }
      })
      this.arcgisElements.measureLayer.remove(this.totalGraphic)
    },

    /**
    * 关闭车辆动态信息框
    */
    onCloseVehicleInfoWindow () {
      this.vehicleInfoModalRef.onClose()
    },
    /**
    * 根据状态返回对应车辆图标文件
    */
    getVehicleMarkerIcon (vehicleInfo, alarm) {
    // 切换车辆状态
      if (!vehicleInfo || !vehicleInfo.info || !vehicleInfo.info.terminalState) {
        return null
      }
      if (this.vehicleInfoModalRef.currentClickedVehicleInfo && this.vehicleInfoModalRef.currentClickedVehicleInfo.id === vehicleInfo.id) {
        return null
      } else {
        if (alarm > 0 && this.onwarn) {
          // 报警
          return '/vehiclealarm.png'
        } else {
          if (vehicleInfo.info.terminalState == '离线') {
            return '/vehicleoffline.png'
          } else if (vehicleInfo.info.terminalState == '停止') {
            return '/vehiclestop.png'
          } else if (vehicleInfo.info.terminalState == '行驶') {
            return '/vehiclerun.png'
          } else if (vehicleInfo.info.terminalState == '停车未熄火') {
            return '/vehiclenospeed.png'
          } else {
            return '/vehicleoffline.png'
          }
        }
      }
    },

    /**
    * wgs84 (高德)转平面投影
    */
    aMapToScreenPoint (lat, lng) {
      let pos = GPS.gcj_encrypt(lat, lng)
      let posChange = new this.arcgisModules.point(pos.lon, pos.lat, this._map.spatialReference)
      // 转换成平面投影坐标系
      posChange = this.arcgisModules.webMercatorUtils.geographicToWebMercator(posChange)
      return posChange
    },
    /**
    * bd09 (百度)转平面投影
    */
    abdMapToScreenPoint (lat, lng) {
      let pos = GPS.bd_decrypt(lat, lng)
      let posChange = new this.arcgisModules.point(pos.lon, pos.lat, this._map.spatialReference)
      // 转换成平面投影坐标系
      posChange = this.arcgisModules.webMercatorUtils.geographicToWebMercator(posChange)
      return posChange
    },
    /**
    * 绘制marker
    * 接收定位数据时回调
    */
    putVehicleMarker (realtimeLocationFrame) {
    // 转换成平面投影坐标系
      let posChange = this.aMapToScreenPoint(realtimeLocationFrame.latitude, realtimeLocationFrame.longitude)

      let vehicleInfo = this._vehicleDymaicManager.findVehicleInfoByTerminalNum(realtimeLocationFrame.terminalNum)
      let realtimeMarker = vehicleInfo.gis.realtimeMarker
      let nameLabel = vehicleInfo.gis.nameLabel
      let tracks = vehicleInfo.gis.tracks

      if (realtimeMarker) {
        // 车辆图标已存在，进行移动操作

        // 移动车辆Marker
        let symbol = realtimeMarker.symbol
        let geometry = realtimeMarker.geometry
        realtimeMarker.setGeometry(posChange)

        // 切换车辆状态
        let iconUrl = this.getVehicleMarkerIcon(vehicleInfo, realtimeLocationFrame.alarm)
        if (iconUrl !== null) {
          symbol.url = iconUrl
        }

        // 旋转车辆图标
        symbol.angle = realtimeLocationFrame.direction

        // 更新轨迹
        if (tracks) {
          let paths = tracks.geometry.paths[0]
          tracks.geometry.insertPoint(0, 0, posChange)
          if (this.isReduceTracks) {
            // 简化轨迹显示
            // tracks.geometry.insertPoint(0, 0, posChange)
            if (paths.length > 10) {
              tracks.geometry.removePoint(0, paths.length - 1)
            }
          }
        }

        // 移动车牌位置
        if (nameLabel) {
          let vehicleNameBg = nameLabel.vehicleNameBg
          let vehicleNameText = nameLabel.vehicleNameText
          if (vehicleNameBg) {
            vehicleNameBg.setGeometry(posChange)
          }
          if (vehicleNameText) {
            vehicleNameText.setGeometry(posChange)
          }
        }
      } else {
        // 新增

        // 创建车辆Marker
        // 切换车辆状态
        let iconUrl = this.getVehicleMarkerIcon(vehicleInfo, realtimeLocationFrame.alarm)
        if (iconUrl !== null) {
          realtimeMarker = new this.arcgisModules.pictureMarkerSymbol(iconUrl, this.vehicleIconSize.width, this.vehicleIconSize.height)
        }
        realtimeMarker.angle = realtimeLocationFrame.direction
        let realtimeMarker = new this.arcgisModules.graphic(posChange, realtimeMarker, {
          markerType: 'realtimeMarker',
          terminalNum: realtimeLocationFrame.terminalNum
        }, null)
        vehicleInfo.gis.realtimeMarker = realtimeMarker
        this.arcgisElements.vehicleMarkerLayer.add(realtimeMarker)

        // 创建轨迹线
        let lineSymbol = new this.arcgisModules.cartographicLineSymbol(
          this.arcgisModules.cartographicLineSymbol.STYLE_SOLID,
          new this.arcgisModules.arcgisColor('#0000FF'), 2,
          this.arcgisModules.cartographicLineSymbol.CAP_ROUND,
          this.arcgisModules.cartographicLineSymbol.JOIN_MITER, 5
        )
        let tracksPolyline = new this.arcgisModules.graphic(
          new this.arcgisModules.polyline({
            paths: [[posChange.x, posChange.y]],
            spatialReference: this._map.spatialReference
          }),
          lineSymbol,
          {},
          null
        )
        vehicleInfo.gis.tracks = tracksPolyline
        this.arcgisElements.tracksLayer.add(tracksPolyline)

        if (this.webconfig.displayRegistration) {
          // 显示车辆名称
          FontUtil.init(9, 'Arial')
          let bgColor = new this.arcgisModules.arcgisColor(vehicleInfo.registrationNum === null ? '#ffffff' : registrationColor(vehicleInfo.registrationColor))
          let fontColor = new this.arcgisModules.arcgisColor(vehicleInfo.registrationNum === null ? '#000000' : registrationTextColor(vehicleInfo.registrationColor))
          let font = new this.arcgisModules.font({ size: 9, family: 'Arial' })
          let vehicleName = (vehicleInfo.registrationNum === null ? vehicleInfo.vin : vehicleInfo.registrationNum)
          if (vehicleInfo.customName) {
            vehicleName = vehicleInfo.customName
          }
          // console.log(vehicleName)
          var bglineSymbol = new this.arcgisModules.simpleLineSymbol('solid', fontColor, 0.5)
          // let vehicleNameLength = stringToByte(vehicleName).length
          let sizeD = FontUtil.computeFontSize(vehicleName)
          var width = sizeD.width + 6
          var height = sizeD.height + 2
          var path = 'M0 ' + height + 'L' + width + ' ' + height + 'L' + width + ' 0L0 0Z'
          var bgSymbol = new this.arcgisModules.simpleMarkerSymbol()
          bgSymbol.setPath(path)
          bgSymbol.setOffset(0, 0 - this.vehicleIconSize.height - (font.size / 2) + 18)
          bgSymbol.setColor(bgColor)
          bgSymbol.setOutline(bglineSymbol)
          // 这个size很重要，边框大小的上限取决于size
          var size = Math.max(height, width)
          bgSymbol.setSize(size)
          var bgGraphic = new this.arcgisModules.graphic(posChange, bgSymbol)
          // bgSymbol.yoffset = this._offsetY;
          this.arcgisElements.vehicleMarkerLayer.add(bgGraphic)
          var vehicleNameSymbol = new this.arcgisModules.textSymbol(vehicleName, font, fontColor)
          // symbol.yoffset = -(font.size / 2) + 31//+ this._offsetY;
          vehicleNameSymbol.yoffset = 0 - this.vehicleIconSize.height - font.size + 19
          var vehicleNameGraphic = new this.arcgisModules.graphic(posChange, vehicleNameSymbol, {})
          this.arcgisElements.vehicleMarkerLayer.add(vehicleNameGraphic)
          vehicleInfo.gis.nameLabel = { vehicleNameText: vehicleNameGraphic, vehicleNameBg: bgGraphic }
          FontUtil.deInit()
        }

        if (this._mapInitZoom === false) {
          // 如果地图未初始化关注中心,则移到该车位置
          this._map.centerAt(posChange)
          this._mapInitZoom = true
        }
      }

      // 更新车辆信息框状态
      if (vehicleInfo.info) {
        if (this.vehicleInfoModalRef.getDisplay()) {
          if (this.vehicleInfoModalRef.currentClickedVehicleInfo && this.vehicleInfoModalRef.currentClickedVehicleInfo.id === vehicleInfo.id) {
            this.vehicleInfoModalRef.updateCurrentClickedVehicleInfoToContent()
            this.vehicleInfoModalRef.moveModalByWebPoint(posChange)
            this._map.centerAt(posChange)
          }
        }
      }

      if (this.vehicleInfoModalRef.currentClickedVehicleInfo && this.vehicleInfoModalRef.currentClickedVehicleInfo.id === vehicleInfo.id) {
        // 如果当前选中车辆则移动到车辆位置
        this._map.centerAt(posChange)
      }
    },

    /**
    * 实时车辆Marker点击回调
    */
    onRealtimeMarkerClick (vehicleInfo, showInfo) {
      let currentClickedVehicleInfo = this.vehicleInfoModalRef.currentClickedVehicleInfo
      if (currentClickedVehicleInfo) {
        if (currentClickedVehicleInfo.gis.tracks) {
          currentClickedVehicleInfo.gis.tracks.symbol.color = new this.arcgisModules.arcgisColor('#0000FF')
        }
        if (currentClickedVehicleInfo.gis.realtimeMarker) {
          let symbol = currentClickedVehicleInfo.gis.realtimeMarker.symbol
          let realtimeLocationFrame = currentClickedVehicleInfo.dymaic.realtimeLocationFrame
          if (realtimeLocationFrame.alarm > 0 && this.onwarn) {
            // 报警
            symbol.url = '/vehiclealarm.png'
          } else {
            if (currentClickedVehicleInfo.info.terminalState == '离线') {
              symbol.url = '/vehicleoffline.png'
            } else if (currentClickedVehicleInfo.info.terminalState == '停止') {
              symbol.url = '/vehiclestop.png'
            } else if (currentClickedVehicleInfo.info.terminalState == '行驶') {
              symbol.url = '/vehiclerun.png'
            } else if (currentClickedVehicleInfo.info.terminalState == '停车未熄火') {
              symbol.url = '/vehiclenospeed.png'
            } else {
              symbol.url = '/vehicleoffline.png'
            }
          }
        }
      }

      this.vehicleInfoModalRef.currentClickedVehicleInfo = vehicleInfo
      currentClickedVehicleInfo = this.vehicleInfoModalRef.currentClickedVehicleInfo

      if (showInfo) {
        let p = vehicleInfo.gis.realtimeMarker.geometry
        this.vehicleInfoModalRef.showModal(this._map, this.arcgisModules, p.x, p.y)
        this.vehicleInfoModalRef.updateCurrentClickedVehicleInfoToContent()
      }
      if (currentClickedVehicleInfo.gis.tracks) {
        currentClickedVehicleInfo.gis.tracks.symbol.color = new this.arcgisModules.arcgisColor('#ff0000')
      }
      if (currentClickedVehicleInfo.gis.realtimeMarker) {
        currentClickedVehicleInfo.gis.realtimeMarker.symbol.url = '/vehicleselected.png'
      }
      if (this.arcgisElements.vehicleMarkerLayer) {
        this.arcgisElements.vehicleMarkerLayer.remove(vehicleInfo.gis.realtimeMarker)
        this.arcgisElements.vehicleMarkerLayer.add(vehicleInfo.gis.realtimeMarker)
        if (vehicleInfo.gis.nameLabel) {
          let vehicleNameText = vehicleInfo.gis.nameLabel.vehicleNameText
          let vehicleNameBg = vehicleInfo.gis.nameLabel.vehicleNameBg
          this.arcgisElements.vehicleMarkerLayer.remove(vehicleNameText)
          this.arcgisElements.vehicleMarkerLayer.remove(vehicleNameBg)
          this.arcgisElements.vehicleMarkerLayer.add(vehicleNameBg)
          this.arcgisElements.vehicleMarkerLayer.add(vehicleNameText)
        }
      }

      this.arcgisElements.vehicleMarkerLayer.redraw()
    },

    /**
    * 取消订阅回调
    * 清除gis元素
    */
    removeVehicleMarker (vehicleInfos) {
      this.vehicleInfoModalRef.currentClickedVehicleInfo = null
      this.vehicleInfoModalRef.onClose()

      vehicleInfos.forEach(vehicleInfo => {
        if (this.arcgisElements.vehicleMarkerLayer && vehicleInfo.gis.realtimeMarker) {
          this.arcgisElements.vehicleMarkerLayer.remove(vehicleInfo.gis.realtimeMarker)
          vehicleInfo.gis.realtimeMarker = null
        }

        if (this.arcgisElements.vehicleMarkerLayer && vehicleInfo.gis.nameLabel) {
          this.arcgisElements.vehicleMarkerLayer.remove(vehicleInfo.gis.nameLabel.vehicleNameText)
          this.arcgisElements.vehicleMarkerLayer.remove(vehicleInfo.gis.nameLabel.vehicleNameBg)
          vehicleInfo.gis.nameLabel = null
        }

        if (this.arcgisElements.tracksLayer && vehicleInfo.gis.tracks) {
          this.arcgisElements.tracksLayer.remove(vehicleInfo.gis.tracks)
          vehicleInfo.gis.tracks = null
        }
      })
    },

    /**
    * 注册地图事件
    */
    registerMapEvent () {
    // 地图加载完成事件
      this._map.on('load', () => {
        console.log('地图加载完成')
        this._map.enableScrollWheelZoom()
        let posChange = this.aMapToScreenPoint(23.135336, 113.271431)
        this._map.centerAndZoom(posChange, 8) // 设置中心点和缩放级别;
        this.createToolbar()
        this.loadCustomPOIs()
      })

      // 地图区域改变
      this._map.on('extent-change', (obj) => {
        var point = this._map.extent.getCenter()
        // console.log(point)
        let GCpoint = this.arcgisModules.webMercatorUtils.webMercatorToGeographic(point)
        // console.log(GCpoint)

        // let WGSpoint = GPS.gcj_decrypt(GCpoint.x,GCpoint.y)
        // console.log(WGSpoint)
        //
        // let BDpoint = GPS.bd_encrypt(GCpoint.x,GCpoint.y)
        // console.log(BDpoint)

        /*reqReverseGeocoderDetail(GCpoint.y, GCpoint.x, address => {
          this.arcgisElements.StreetLayer.clear()

          // let startImg = new this.arcgisModules.pictureMarkerSymbol({ 'url': '/delete.jpg', 'height': 5, 'width': 5 })
          // let startGraphic = new this.arcgisModules.graphic(point, startImg, {}, null)
          // this.arcgisElements.StreetLayer.add(startGraphic)

          // console.log(address)
          // console.log(address.addressComponent)
          let cityfont = new this.arcgisModules.font({ size: 15, family: 'Arial' })
          let cityfontColor = new this.arcgisModules.arcgisColor('rgba(252,0,0,0.7)')
          let streetcitysymbol = new this.arcgisModules.textSymbol(address.addressComponent.city, cityfont, cityfontColor)
          streetcitysymbol.yoffset = 12 + cityfont.size
          let streetcitygraphic = new this.arcgisModules.graphic(point, streetcitysymbol)
          this.arcgisElements.StreetLayer.add(streetcitygraphic)

          let districtfont = new this.arcgisModules.font({ size: 10, family: 'Arial' })
          let districtfontColor = new this.arcgisModules.arcgisColor('rgba(14,19,255,0.7)')

          if (this._map.getLevel() > 10) {
            // 百度逆地址解释
            let streetdistrictsymbol = new this.arcgisModules.textSymbol(address.addressComponent.district + address.addressComponent.street, districtfont, districtfontColor)

            // 高德逆地址解释
            // let streetdistrictsymbol = new this.arcgisModules.textSymbol(address.addressComponent.district+address.addressComponent.district+address.addressComponent.township, districtfont, districtfontColor)
            streetdistrictsymbol.yoffset = 5 + districtfont.size
            let streetdistrictgraphic = new this.arcgisModules.graphic(point, streetdistrictsymbol)

            this.arcgisElements.StreetLayer.add(streetdistrictgraphic)
          }
        })*/

        let level = this._map.getLevel()
        let pres = Math.min(6, level)
        this.leftTop = { x: obj.extent.xmin, y: obj.extent.ymax }
        this.rightBottom = { x: obj.extent.xmax, y: obj.extent.ymin }
        let v = this.arcgisModules.webMercatorUtils.xyToLngLat(this.leftTop.x.toFixed(pres), this.leftTop.y.toFixed(pres))
        this.leftTop = GPS.gcj_decrypt(v[1], v[0])
        v = this.arcgisModules.webMercatorUtils.xyToLngLat(this.rightBottom.x.toFixed(pres), this.rightBottom.y.toFixed(pres))
        this.rightBottom = GPS.gcj_decrypt(v[1], v[0])
      })

      // 注册点击事件
      this._map.on('click', (event) => {
        // console.log(event)

        this.onMeasureMapClick(event)
        if (event.graphic && event.graphic.attributes && event.graphic.attributes.markerType === 'realtimeMarker') {
          // 动态车辆点击
          let attributes = event.graphic.attributes
          let vehicleInfo = this._vehicleDymaicManager.findVehicleInfoByTerminalNum(attributes.terminalNum)
          this.onRealtimeMarkerClick(vehicleInfo, true)
        } else {
          // this.vehicleInfoModalRef.onClose()
          this.unSelectVehicle()
        }
        if (event.graphic && event.graphic.attributes && event.graphic.attributes.markerType === 'customPOI') {
          // console.log('customPOI')
          // console.log(event.graphic)
          let point = event.graphic.geometry
          this.customerPointDetailModalRef.showModal(event.graphic.attributes.customPOIId, this._map, this.arcgisModules, point.x, point.y)
        }
        if (event.graphic && event.graphic.attributes && event.graphic.attributes.markerType === 'deletedistance') {
        // console.log('deletedistance')
        // console.log(event.graphic)
        // console.log(this.deletedistancelists)
        // this.arcgisElements.measureLayer.remove(this.deletedistance)
          for (let i = 0; i < this.deletedistancelists.length; i++) {
            this.deletedistancelists[event.graphic.attributes.deletedistanceId]
            // console.log(this.deletedistancelists[event.graphic.attributes.deletedistanceId])
            this.deletedistancelists[event.graphic.attributes.deletedistanceId].forEach(item => {
              this.arcgisElements.measureLayer.remove(item)
            })
          }
        }
      })

      // 注册双击事件
      this._map.on('dbl-click', (event) => {
      // console.log(event)
      // console.log(this._map.getZoom())
        if (event.graphic && event.graphic.attributes && event.graphic.attributes.markerType === 'realtimeMarker' && this._map.getZoom() != 15) {
          this._map.centerAndZoom(event.graphic.geometry, 15)
        }
        if (this.deletedistancelist.length != 0) {
          this.deletedistancelists.push(this.deletedistancelist)
          this.deletedistancelist = []
          // console.log(this.deletedistancelists)
        }
      })

      // 移动开始事件
      this._map.on('pan', pan => {
        if (this.vehicleInfoModalRef) {
          this.vehicleInfoModalRef.onMapPan(pan.delta)
        }
        if (this.addCustomerPointModalRef != null) {
          this.addCustomerPointModalRef.onMapPan(pan.delta)
        }
        if (this.customerPointDetailModalRef != null) {
          this.customerPointDetailModalRef.onMapPan(pan.delta)
        }
        if (this.modifyCustomerPointModalRef != null) {
          this.modifyCustomerPointModalRef.onMapPan(pan.delta)
        }
      })

      // 平移结束事件
      this._map.on('pan-end', panend => {
        if (this.vehicleInfoModalRef) {
          this.vehicleInfoModalRef.onMapPanEnd(panend.delta)
        }
        if (this.addCustomerPointModalRef) {
          this.addCustomerPointModalRef.onMapPanEnd(panend.delta)
        }
        if (this.customerPointDetailModalRef != null) {
          this.customerPointDetailModalRef.onMapPanEnd(panend.delta)
        }
        if (this.modifyCustomerPointModalRef != null) {
          this.modifyCustomerPointModalRef.onMapPanEnd(panend.delta)
        }
      })

      // 缩放开始事件
      this._map.on('zoom', () => {
        if (this.vehicleInfoModalRef) {
          this.vehicleInfoModalRef.onMapZoom()
        }
        if (this.addCustomerPointModalRef) {
          this.addCustomerPointModalRef.onMapZoom()
        }
        if (this.customerPointDetailModalRef != null) {
          this.customerPointDetailModalRef.onMapZoom()
        }
        if (this.modifyCustomerPointModalRef != null) {
          this.modifyCustomerPointModalRef.onMapZoom()
        }
      })

      // 缩放结束事件
      this._map.on('zoom-end', () => {
        if (this.vehicleInfoModalRef) {
          this.vehicleInfoModalRef.onMapZoomEnd()
        }
        if (this.addCustomerPointModalRef) {
          this.addCustomerPointModalRef.onMapZoomEnd()
        }
        if (this.customerPointDetailModalRef != null) {
          this.customerPointDetailModalRef.onMapZoomEnd()
        }
        if (this.modifyCustomerPointModalRef != null) {
          this.modifyCustomerPointModalRef.onMapZoomEnd()
        }
        if (this._map.getZoom() > 11 && this.showpoi) {
          this.arcgisElements.poiLayer.show()
        } else {
          this.arcgisElements.poiLayer.hide()
        }
      })

      this._map.on('mouse-move', (e) => {
        if (this.showMouseLatLng) {
          let level = this._map.getLevel()
          let pres = Math.min(6, level)
          let v = this.arcgisModules.webMercatorUtils.xyToLngLat(e.mapPoint.x.toFixed(pres), e.mapPoint.y.toFixed(pres))
          let pos = GPS.gcj_decrypt(v[1], v[0])
          this.mouseLng = pos.lon
          this.mouseLat = pos.lat
        }
      })
      this._map.on('click', (e) => {
        if (this.StartMouseLatLng) {
          let level = this._map.getLevel()
          let pres = Math.min(6, level)
          let v = this.arcgisModules.webMercatorUtils.xyToLngLat(e.mapPoint.x.toFixed(pres), e.mapPoint.y.toFixed(pres))
          let pos = GPS.gcj_decrypt(v[1], v[0])
          this.StartmouseLng = v[0]
          this.StartmouseLat = v[1]
          // this._map.click(this.StartMouseLatLng=false)
          this.StartMouseLatLng = false
        }
        if (this.EndMouseLatLng) {
          let level = this._map.getLevel()
          let pres = Math.min(6, level)
          let v = this.arcgisModules.webMercatorUtils.xyToLngLat(e.mapPoint.x.toFixed(pres), e.mapPoint.y.toFixed(pres))
          let pos = GPS.gcj_decrypt(v[1], v[0])
          this.EndmouseLng = v[0]
          this.EndmouseLat = v[1]
          this.EndMouseLatLng = false
        }

        let startImg = new this.arcgisModules.pictureMarkerSymbol({ 'url': '/start.png', 'height': 20, 'width': 18, 'yoffset': 10 })
        let endImg = new this.arcgisModules.pictureMarkerSymbol({ 'url': '/end.png', 'height': 20, 'width': 18, 'yoffset': 10 })

        // 起点标识graphic
        if (this.StartmouseLng != 0) {
          let startPoint = new this.arcgisModules.point(this.StartmouseLng, this.StartmouseLat)
          let startGraphic = new this.arcgisModules.graphic(startPoint, startImg, {}, null)
          this.arcgisElements.navigationer.add(startGraphic)
        }

        // 终点标识graphic
        if (this.EndmouseLng != 0) {
          let endPoint = new this.arcgisModules.point(this.EndmouseLng, this.EndmouseLat)
          let endGraphic = new this.arcgisModules.graphic(endPoint, endImg, {}, null)
          this.arcgisElements.navigationer.add(endGraphic)
        }

        /**
      * 添加graphic到tracksLayer图层
      */
        // this.arcgisElements.tracksLayer.redraw()

        console.log('结束')
      })
    },

    /**
    * 取消关注
    */
    unSelectVehicle () {
      if (!this.vehicleInfoModalRef.currentClickedVehicleInfo) {
        return
      }
      let currentClickedVehicleInfo = this.vehicleInfoModalRef.currentClickedVehicleInfo

      if (currentClickedVehicleInfo.gis.tracks) {
        currentClickedVehicleInfo.gis.tracks.symbol.color = new this.arcgisModules.arcgisColor('#0000FF')
      }
      if (currentClickedVehicleInfo.gis.realtimeMarker) {
        let symbol = currentClickedVehicleInfo.gis.realtimeMarker.symbol
        let realtimeLocationFrame = currentClickedVehicleInfo.dymaic.realtimeLocationFrame
        if (realtimeLocationFrame.alarm > 0 && this.onwarn) {
          // 报警
          symbol.url = '/vehiclealarm.png'
        } else {
          if (currentClickedVehicleInfo.info.terminalState == '离线') {
            symbol.url = '/vehicleoffline.png'
          } else if (currentClickedVehicleInfo.info.terminalState == '停止') {
            symbol.url = '/vehiclestop.png'
          } else if (currentClickedVehicleInfo.info.terminalState == '行驶') {
            symbol.url = '/vehiclerun.png'
          } else if (currentClickedVehicleInfo.info.terminalState == '停车未熄火') {
            symbol.url = '/vehiclenospeed.png'
          } else {
            symbol.url = '/vehicleoffline.png'
          }
        }
        this.vehicleInfoModalRef.onClose()
        this.arcgisElements.vehicleMarkerLayer.redraw()
      }
    },

    /**
    * 初始化GIS元素
    */
    initGisElements () {
    // 加载js
      esriLoader.loadScript({
        url: 'https://webgis.jianchengjt.com/arcgis_js_api/library/3.29/3.29/'
      })

      // 加载css
      esriLoader.loadCss('https://webgis.jianchengjt.com/arcgis_js_api/library/3.29/3.29/esri/css/esri.css')
      esriLoader.loadCss('https://webgis.jianchengjt.com/arcgis_js_api/library/3.29/3.29/dijit/themes/nihilo/nihilo.css')

      // 加载模块
      esriLoader.loadModules([
        'esri/map',
        'src/GaodeLayer',
        'src/Gaode/GaodeCondition',
        'dojo/parser',
        'dojo/domReady!',
        'dojo/dom-construct',
        'esri/symbols/PictureMarkerSymbol',
        'esri/geometry/Point',
        'esri/graphic',
        'esri/geometry/webMercatorUtils',
        'esri/geometry/Polyline',
        'esri/symbols/CartographicLineSymbol',
        'esri/Color',
        'esri/layers/GraphicsLayer',
        'esri/layers/FeatureLayer',
        'esri/symbols/TextSymbol',
        'esri/symbols/SimpleLineSymbol',
        'esri/symbols/SimpleMarkerSymbol',
        'esri/symbols/SimpleFillSymbol',
        'esri/symbols/Font',
        'esri/InfoWindowBase',
        'esri/toolbars/draw',
        'esri/tasks/LengthsParameters',
        'esri/tasks/AreasAndLengthsParameters',
        'esri/tasks/GeometryService',
        'esri/dijit/OverviewMap'
      ]).then(([Map, GaodeLayer, GaodeCondition, parser, domReady, domConstruct, arcgisPictureMarkerSymbol, arcgisPoint, graphic, webMercatorUtils, polyline, cartographicLineSymbol, arcgisColor, graphicsLayer, featureLayer, textSymbol, simpleLineSymbol, simpleMarkerSymbol, simpleFillSymbol, font, infoWindowBase, toolbarsDraw, lengthsParameters, areasAndLengthsParameters, geometryService, overviewMap]) => {
        this.arcgisModules.pictureMarkerSymbol = arcgisPictureMarkerSymbol
        this.arcgisModules.point = arcgisPoint
        this.arcgisModules.graphic = graphic
        this.arcgisModules.webMercatorUtils = webMercatorUtils
        this.arcgisModules.polyline = polyline
        this.arcgisModules.cartographicLineSymbol = cartographicLineSymbol
        this.arcgisModules.arcgisColor = arcgisColor
        this.arcgisModules.graphicsLayer = graphicsLayer
        this.arcgisModules.featureLayer = featureLayer
        this.arcgisModules.textSymbol = textSymbol
        this.arcgisModules.simpleLineSymbol = simpleLineSymbol
        this.arcgisModules.simpleMarkerSymbol = simpleMarkerSymbol
        this.arcgisModules.simpleFillSymbol = simpleFillSymbol
        this.arcgisModules.font = font
        this.arcgisModules.infoWindowBase = infoWindowBase
        this.arcgisModules.domConstruct = domConstruct
        this.arcgisModules.toolbarsDraw = toolbarsDraw
        this.arcgisModules.lengthsParameters = lengthsParameters
        this.arcgisModules.areasAndLengthsParameters = areasAndLengthsParameters
        this.arcgisModules.geometryService = geometryService
        this.arcgisModules.overviewMap = overviewMap
        parser.parse()
        this._map = new Map('map', {
          webglEnabled: true,
          optimizePanAnimation: false,
          isZoomSlider: true,
          isPanArrows: true,
          isPan: true,
          isScrollWheel: true,
          isScrollWheelZoom: true,
          logo: false,
          fadeOnZoom: false,
          force3DTransforms: true,
          navigationMode: 'classic',
          center: [105.9, 36.7],
          zoom: 5
        })

        // 注册地图事件
        this.registerMapEvent()

        // 加载地图
        let gdlayer = new GaodeLayer()
        // setInterval(
        this._gdlayer = gdlayer
        // ,1500)
        this._map.addLayer(gdlayer)

        // 加载实时路况
        let gaodeCondition = new GaodeCondition()
        this.arcgisElements.realtimeTraffic = gaodeCondition
        this._map.addLayer(gaodeCondition)
        this.arcgisElements.realtimeTraffic.hide()

        // 市区街道显示层
        let StreetLayer = new this.arcgisModules.graphicsLayer({ visibleAtMapScale: true })
        this.arcgisElements.StreetLayer = StreetLayer
        this._map.addLayer(StreetLayer)

        // 创建自定义地物点图层
        this.arcgisElements.poiLayer = new this.arcgisModules.graphicsLayer({ visibleAtMapScale: true })
        this._map.addLayer(this.arcgisElements.poiLayer)

        // 创建车辆轨迹图层
        let tracksLayer = new this.arcgisModules.graphicsLayer({ visibleAtMapScale: true })
        this.arcgisElements.tracksLayer = tracksLayer
        this._map.addLayer(tracksLayer)

        // 创建车辆图标图层
        let vehicleMarkerLayer = new this.arcgisModules.graphicsLayer({ visibleAtMapScale: true })
        this.arcgisElements.vehicleMarkerLayer = vehicleMarkerLayer
        this._map.addLayer(vehicleMarkerLayer)

        // 测量层
        let measureLayer = new this.arcgisModules.graphicsLayer({ visibleAtMapScale: true })
        this.arcgisElements.measureLayer = measureLayer
        this._map.addLayer(measureLayer)

        // 搜索POI层
        let searchPOILayer = new this.arcgisModules.graphicsLayer({ visibleAtMapScale: true })
        this.arcgisElements.searchPOILayer = searchPOILayer
        this._map.addLayer(searchPOILayer, 0)

        // 创建导航图层
        let navigationer = new this.arcgisModules.graphicsLayer({ visibleAtMapScale: true })
        this.arcgisElements.navigationer = navigationer
        this._map.addLayer(navigationer, 1)
      }).catch((err) => {
        console.log(err.message)
      })
    },

    /**
    * 高德实时路况
    */
    realtimeTraffic () {
    // 实时路况
      if (this.showTraffic) {
        this.arcgisElements.realtimeTraffic.hide()
        this.showTraffic = false
      } else {
        // this.arcgisElements.realtimeTraffic.redraw()
        this.arcgisElements.realtimeTraffic.show()
        this.showTraffic = true
      }
    },
    /**
 *返回指定位置
 */
    goBack () {
    // console.log(this._map.getZoom())
      this._map.centerAndZoom(new this.arcgisModules.point(12619437.592678737, 2573613.5381193617, this._map.spatialReference), 11)
    },

    /**
    * 设置地图中心点
    */
    mapCenterAt (point) {
      // console.log(point)
      this._map.centerAt(point)
    },

    /**
    * 保存修改自定义点回调
    */
    onCustomPOIModify (id) {
      if (this.arcgisElements.poiLayer) {
        let removeGraphics = new Array(3)
        forEach(this.arcgisElements.poiLayer.graphics, (item) => {
          if (item.attributes.customPOIId == id) {
            removeGraphics.push(item)
          }
        })
        forEach(removeGraphics, (item) => {
          this.arcgisElements.poiLayer.remove(item)
        })
      }
      let bgColor = new this.arcgisModules.arcgisColor('rgba(255,255,255,0.7)')
      let fontColor = new this.arcgisModules.arcgisColor('rgba(0,0,0,0.7)')
      let font = new this.arcgisModules.font({ size: 9, family: 'Arial' })
      store.dispatch('CustomPOIServ_GetDetail', {
        params: { id: id },
        urlparams: null
      }).then(() => {
        // console.log(store.getters.get_CustomPOI_GetDetailResult)
        FontUtil.init(9, 'Arial')
        this.addCustomPOI(store.getters.get_CustomPOI_GetDetailResult, fontColor, font, bgColor)
        FontUtil.deInit()
      }).catch(err => {
        this.$Message.error(err)
        console.log(err)
      })
    },

    /**
    * 添加自定义点回调
    */
    onCustomPOIAdd (id) {
      let bgColor = new this.arcgisModules.arcgisColor('rgba(255,255,255,0.7)')
      let fontColor = new this.arcgisModules.arcgisColor('rgba(0,0,0,0.7)')
      let font = new this.arcgisModules.font({ size: 9, family: 'Arial' })
      store.dispatch('CustomPOIServ_GetDetail', {
        params: { id: id },
        urlparams: null
      }).then(() => {
        // console.log(store.getters.get_CustomPOI_GetDetailResult)
        FontUtil.init(9, 'Arial')
        this.addCustomPOI(store.getters.get_CustomPOI_GetDetailResult, fontColor, font, bgColor)
        FontUtil.deInit()
      }).catch(err => {
        this.$Message.error(err)
        console.log(err)
      })
    },

    /**
    * 编辑自定义点回调
    */
    onCustomPOIEdit (id) {
      let point = this.customerPointDetailModalRef.mapInfoModalRef.beforeMapPoint
      this.customerPointDetailModalRef.onClose()
      this.modifyCustomerPointModalRef.showModal(id, this._map, this.arcgisModules, point.x, point.y)
    },

    /**
    * 删除自定义点回调
    */
    onCustomPOIDeleted (id) {
      if (this.arcgisElements.poiLayer) {
        let removeGraphics = new Array(3)
        forEach(this.arcgisElements.poiLayer.graphics, (item) => {
          if (item.attributes.customPOIId == id) {
            removeGraphics.push(item)
          }
        })
        forEach(removeGraphics, (item) => {
          this.arcgisElements.poiLayer.remove(item)
        })
      }
    },

    addCustomPOI (item, fontColor, font, bgColor) {
      let pos = GPS.gcj_encrypt(item.latitude, item.longitude)
      let posChange = new this.arcgisModules.point(pos.lon, pos.lat, this._map.spatialReference)
      posChange = this.arcgisModules.webMercatorUtils.geographicToWebMercator(posChange)
      let logoSymbol = new this.arcgisModules.pictureMarkerSymbol({
        url: '/pin.png',
        width: 7,
        height: 14,
        yoffset: 7
      })
      let logoGraphic = new this.arcgisModules.graphic(posChange, logoSymbol, {
        customPOIId: item.id,
        markerType: 'customPOI'
      }, null)
      let bglineSymbol = new this.arcgisModules.simpleLineSymbol('solid', fontColor, 0.5)
      // let width = item.name.length * (font.size);
      // let height = font.size * 1.3;
      let fontSize = FontUtil.computeFontSize(item.name)
      let width = fontSize.width + 6
      let height = fontSize.height + 2
      // 画边框
      let path = 'M0 ' + height + 'L' + width + ' ' + height + 'L' + width + ' 0L0 0Z'
      let bgSymbol = new this.arcgisModules.simpleMarkerSymbol()
      bgSymbol.setPath(path)
      bgSymbol.setOffset(0, 12 + font.size * 1.3)
      bgSymbol.setColor(bgColor)
      // console.log(bgColor)
      // bgSymbol.setStyle(opacity)
      bgSymbol.setOutline(bglineSymbol)
      // 这个size很重要，边框大小的上限取决于size
      let size = Math.max(height, width)
      bgSymbol.setSize(size)
      let bgGraphic = new this.arcgisModules.graphic(posChange, bgSymbol, {
        customPOIId: item.id,
        markerType: 'customPOINameBg'
      }, null)
      this.arcgisElements.poiLayer.add(bgGraphic)
      let symbol = new this.arcgisModules.textSymbol(item.name, font, fontColor)
      symbol.yoffset = 12 + font.size
      let graphic = new this.arcgisModules.graphic(posChange, symbol, {
        customPOIId: item.id,
        markerType: 'customPOIName'
      })
      this.arcgisElements.poiLayer.add(graphic)
      this.arcgisElements.poiLayer.add(logoGraphic)
      this.arcgisElements.poiLayer.hide()
    },

    /**
    * 加载客户自定义POI点
    */
    loadCustomPOIs () {
    // 加载客户自定义poi点
      console.log('加载POI')
      store.dispatch('CustomPOIServ_GetMyAll', {
        params: null,
        urlparams: null
      }).then(() => {
        let allCustomPOI = store.getters.get_CustomPOI_GetMyAllResult
        let points = []
        try {
          console.log('获取poi完成')
          let bgColor = new this.arcgisModules.arcgisColor('rgba(255,255,255,0.7)')
          let fontColor = new this.arcgisModules.arcgisColor('rgba(0,0,0,0.7)')
          let font = new this.arcgisModules.font({ size: 9, family: 'Arial' })
          FontUtil.init(9, 'Arial')
          allCustomPOI.forEach(item => {
            this.addCustomPOI(item, fontColor, font, bgColor)
          })
          // console.log(this._map.getZoom())
          if (this._map.getZoom() > 11) {
            this.arcgisElements.poiLayer.show()
          }
          FontUtil.deInit()
        } catch (e) {
          console.log(e)
        }
      }).catch(err => {
        this.$Message.error(err)
        console.log(err)
      })
    },

    /**
    * 创建统计任务
    */
    createCalculateTask () {
      this.refreshTaskTimer = setInterval(() => {
        if (this.arcgisElements.tracksLayer) {
          this.arcgisElements.tracksLayer.redraw()
        }
      }, 1000)
    },

    /**
    * 销毁统计任务
    */
    destoryCalculateTask () {
      if (this.refreshTaskTimer) {
        clearInterval(this.refreshTaskTimer)
        this.refreshTaskTimer = null
      }
    },

    /**
    * 封装车牌颜色底色方法
    */
    registrationColorCompute (val) {
      return registrationColor(val)
    },

    /**
    * 封装车牌颜色文字颜色方法
    */
    registrationTextColorCompute (val) {
      return registrationTextColor(val)
    }

  },
  beforeDestroy () {
    this.destoryCalculateTask()
  },

  computed: {
    _vehicleDymaicManager: {
      get () {
        return this.vehicleDymaicManager
      },

      set (val) {
        // this.$emit('input', val)
        // this.$emit('change', val)
      }
    }
  },

  mounted () {
    this.$nextTick(() => {
      this.addCustomerPointModalRef = this.$refs.addCustomerPointModalRef
      this.customerPointDetailModalRef = this.$refs.customerPointDetailModalRef
      this.modifyCustomerPointModalRef = this.$refs.modifyCustomerPointModalRef
      this.vehicleInfoModalRef = this.$refs.vehicleInfoModalRef

      // 加载省数据
      this.provinceList = areaDataJson.districts
      setTimeout(() => {
        this.createCalculateTask()
      }, 200)
      // 初始化GIS元素
      this.initGisElements()
    })
  }
}
</script>
<style lang="less">

</style>
